import {DlSelectOption} from '@wallaby-ui/core';
import {sortBy} from 'lodash';
import React, {useMemo} from 'react';
import {Options} from 'react-select';
import {MEDICATIONS_REDUCER_STATE_ID} from 'src/js/containers/medications/medications_constants';
import {useAppSelector} from 'src/js/store_hooks';

import {
  FilterNodeTypeHierarchySyncMultiSelectContainer,
  FilterNodeTypeHierarchySyncMultiSelectContainerProps,
} from './FilterNodeTypeHierarchySyncMultiSelectContainer';
import {getSelectOptionIdProperty} from '../filtering_helpers';

interface OwnProps
  extends Omit<FilterNodeTypeHierarchySyncMultiSelectContainerProps, 'data' | 'options' | 'valueProperty' | 'hierarchyData'> {
  marginBlock?: string;
}

type Props = OwnProps;

/** @deprecated TODO: remove this, use `<LightMedicationAtcFilter2>` instead */
export const FilterNodeTypeMedications: React.FC<Props> = (props) => {
  const {isMui, ...restProps} = props;
  const medications = useAppSelector((state) => state[MEDICATIONS_REDUCER_STATE_ID].filterData);

  const idProperty = getSelectOptionIdProperty(isMui);
  const options = useMemo<Options<DlSelectOption>>(() => {
    return sortBy(
      medications.map((item) => {
        return {
          value: item.id.toString(),
          [idProperty]: item.id.toString(),
          label: item.label,
        };
      }),
      'label'
    );
  }, [idProperty, medications]);

  return (
    <FilterNodeTypeHierarchySyncMultiSelectContainer
      {...restProps}
      options={options}
      valueProperty={idProperty}
      hierarchyData={medications}
      isMui={isMui}
    />
  );
};

FilterNodeTypeMedications.displayName = 'FilterNodeTypeMedications';
